import axios from 'axios';

interface HandlePostJobdomParams {
  isWriteMode: boolean;
  category: string;
  content: string;
  password: string;
  selectedCompanyHash: string;
  hashtags: string[];
  title: string;
  userName: string;
  jobdomNumber?: number;
}

export function handlePostJobdom({
  jobdomNumber,
  isWriteMode,
  category,
  content,
  password,
  selectedCompanyHash,
  hashtags,
  title,
  userName,
}: HandlePostJobdomParams) {
  if (!title) {
    alert('제목을 입력해주세요.');

    return;
  }

  if (!content) {
    alert('내용을 입력해주세요.');

    return;
  }

  if (!userName) {
    alert('닉네임을 입력해주세요.');

    return;
  }

  if (!password || password.length < 4) {
    alert('비밀번호를 입력해주세요.');

    return;
  }
  const payload: any = {
    CATEGORY_ID: category ?? 'N',
    CONTENT: content,
    PASSWORD: password,
    PK_NM_HASH: selectedCompanyHash || '',
    TAG_LIST: hashtags || '',
    TITLE: title,
    USER_NAME: userName,
  };
  const apiUrl = isWriteMode ? '/api/jobdom/write' : '/api/jobdom/edit';

  if (!isWriteMode) {
    payload['JOBDOM_NO'] = jobdomNumber;
  }

  return isWriteMode ? axios.post(apiUrl, payload) : axios.put(apiUrl, payload);
}

export function isInvalidHashTags(hashtags?: string[]) {
  return hashtags?.length === 0 || (hashtags?.length === 1 && hashtags[0] === '');
}
